import { render, staticRenderFns } from "./ZumaLink.vue?vue&type=template&id=675cd463&"
import script from "./ZumaLink.vue?vue&type=script&lang=js&"
export * from "./ZumaLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('675cd463')) {
      api.createRecord('675cd463', component.options)
    } else {
      api.reload('675cd463', component.options)
    }
    module.hot.accept("./ZumaLink.vue?vue&type=template&id=675cd463&", function () {
      api.rerender('675cd463', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ZumaLink.vue"
export default component.exports